import React, { memo, useCallback } from "react";
import PropTypes from "prop-types";
import { ToggleThumb, ToggleTrack } from "./elements";

export const BettoToggle = memo(({ active, onChange, disabled, "aria-label": ariaLabel }) => {
	const handleClick = useCallback(() => {
		if (!disabled && onChange) {
			onChange(!active);
		}
	}, [active, disabled, onChange]);

	return (
		<ToggleTrack
			type="button"
			role="switch"
			aria-checked={active}
			aria-label={ariaLabel}
			disabled={disabled}
			$active={active}
			onClick={handleClick}>
			<ToggleThumb $active={active} />
		</ToggleTrack>
	);
});

BettoToggle.displayName = "BettoToggle";

BettoToggle.propTypes = {
	active: PropTypes.bool,
	onChange: PropTypes.func,
	disabled: PropTypes.bool,
	"aria-label": PropTypes.string,
};
